// Clear CID or Coupon from reservation and create/dispatch a deeplink
import RESERVATIONS from 'constants/reservations';
import { getModifyFlag } from 'selectors';
import { gboReservationPath, gmaReservationPath } from 'paths/session';
import utils from 'utils';
import actions from '@ehi/global-marketing-interface/lib/actions';
import { setCoupon } from 'actions/reservation/setCoupon';
import { initiateReservationFlow } from 'actions/reservation/initiateReservationFlow';
import { uiStateReservationCommitPath } from 'paths/uiState';
import { deeplinkIntoReservationFlow } from 'actions/reservation/deeplinkIntoReservationFlow';

const setContractDetailsGmaData = (data) => ({
  type: RESERVATIONS.EDIT_CID_GMA,
  data,
});

export const clearDiscountInReservationFlow =
  ({ coupons = false, product_code = false } = {}) =>
  (dispatch, getState) => {
    const { RESFLOW_PATHS_CONFIG, RESFLOW_DEEPLINK_STOPS } = RESERVATIONS;
    const state = getState();
    const isTrueModify = getModifyFlag(state);
    let removeTarget = 'contract_number';

    if (coupons) {
      removeTarget = 'coupons';
    } else if (product_code) {
      removeTarget = 'product_code';
    }

    const newReservationObjWithoutTarget = state?.getIn(gboReservationPath)?.delete(removeTarget);
    const reservation = utils.safeToJS(newReservationObjWithoutTarget);
    const gmaReservation = utils.safeToJS(state?.getIn(gmaReservationPath));

    // if there is no reservation in gbo session, but there is one in gma session,
    // we need to clear contact details on gma session, this happens on map_pickup page
    if (gmaReservation && !reservation) {
      // this is to clear the contract on BE/gbo session so once user selects
      // an airport and continues to the reservation flow, the contract is not carried over
      dispatch(actions.reservations.initiateState.unset('contract'));
      // this is to clear the redux state on map_pickup page and user don't get to see the contract number there anymore
      dispatch(setContractDetailsGmaData(null));
    }

    // If there is no reservation in session, no need to clear data for deeplink
    // e.g.: removing discount code from a failed deeplink in #start step
    if (!reservation) {
      return;
    }

    // This is needed on contract_number because hasContract in gmi.getReservationDeepLinkParams function has contract_details.contract_number in it's validation
    if (removeTarget === 'contract_number' && reservation?.contract_details?.contract_number) {
      delete reservation.contract_details.contract_number;
      dispatch(actions.reservations.initiateState.unset('contract'));
    } else if (removeTarget === 'product_code') {
      const vehicleRates = reservation.car_class_details.vehicle_rates;
      Object.assign(
        vehicleRates,
        vehicleRates.map((rate) => delete rate?.product_code && rate)
      );
    } else if (removeTarget === 'coupons' && isTrueModify) {
      dispatch(setCoupon());
      dispatch(initiateReservationFlow({ saveLatestSelections: true }));
      return;
    }

    const commitState = state?.getIn(uiStateReservationCommitPath);

    // To keep the user in the same page after doing the deeplink, we check for
    // the window hash step and add the stop parameter with the step key.
    const windowHash = window.location.hash.replace('#', '');
    const currentStep = Object.keys(RESFLOW_PATHS_CONFIG).find((key) => RESFLOW_PATHS_CONFIG[key].includes(windowHash));
    const stop = windowHash && RESFLOW_DEEPLINK_STOPS[currentStep];

    const deeplinkReservationObj = { ...reservation, ...utils.safeToJS(commitState) };
    const deeplinkParams = utils.gmi.getReservationDeepLinkParams(deeplinkReservationObj, stop || '');

    dispatch(deeplinkIntoReservationFlow(deeplinkParams, { loadingOverlay: true, initVehicleFilters: true }));
  };
